import { TextSvgCellrenderComponent } from '../../../../shared/common-components/ag-grid/text-svg-cellrender/text-svg-cellrender.component';
import { CustomHeaderComponent } from '../../../../shared/common-components/ag-grid/custom-header/custom-header.component';
import { AgColDefsI, AgGridI } from '../../../../shared/common-components/ag-grid/ag-grid.model';
import { TextRendererComponent } from '../../../../../../src/app/shared/common-components/ag-grid/text-renderer/text-renderer.component';
import { AgGridCustomDropdownComponent } from 'src/app/shared/common-components/ag-grid/ag-grid-custom-dropdown/ag-grid-custom-dropdown.component';
import { PlusIconComponent } from 'src/app/shared/common-components/ag-grid/plus-icon/plus-icon.component';
import { ResetDeleteIconComponent } from 'src/app/shared/common-components/ag-grid/reset-delete-icon/reset-delete-icon.component';
import { CustomExpandableComponent } from 'src/app/shared/common-components/ag-grid/custom-expandable/custom-expandable.component';
import { DatePipe } from '@angular/common';

// const Type: AgColDefsI = {
//     headerName: "Type", 
//     field: 'type', 
//     headerComponent: CustomHeaderComponent,
//     minWidth: 150,
//     sortable: true,
//     editable:false,
//     headerClass:'pe-2',
//     cellClass:"ps-2",
//     cellRendererParams :{isCursor:true,textPrimary:true},
//     cellRenderer:TextRendererComponent
//   };
//   const TransferFrom: AgColDefsI = {
//     headerName: "Transfer From", 
//     field: 'TransferFrom', 
//     minWidth: 150,
//     maxWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     sortable: true,
//     editable:false,
//     cellClass:"ps-2",
//     cellRenderer:TextRendererComponent
//   };
//   const DepositInto: AgColDefsI = {
//     headerName: "Deposit Into", 
//     field: 'depositInto', 
//     minWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     sortable: true,
//     editable:false,
//     cellClass:"ps-2",
//     cellRenderer:TextRendererComponent
//   };
//   const Against: AgColDefsI = {
//     headerName: "Against", 
//     field: 'against', 
//     minWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     sortable: true,
//     editable:false,
//     cellClass:"ps-2",
//     cellRenderer:TextRendererComponent
//   };
//   const TransactionNo: AgColDefsI = {
//     headerName: "Transaction No.", 
//     field: 'transactionNo', 
//     minWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     sortable: true,
//     editable:false,
//     cellClass:"ps-2",
//     cellRenderer: TextRendererComponent,
//   };
//   const TransactionDt: AgColDefsI = {
//     headerName: "Transaction Dt.", 
//     field: 'transactionDt', 
//     minWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     sortable: true,
//     cellClass:"ps-2",
//     editable:false,
//     cellRenderer: TextSvgCellrenderComponent,

//   };
//   const AmountColumn: AgColDefsI = {
//     headerName: "Amount", 
//     field: 'amount', 
//     minWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     headerComponentParams:{
//       enablePlusIcon:true,
//     },
//     sortable: true,
//     editable:false,
//    cellClass:"ps-2",
//     cellRenderer:TextRendererComponent
//   };
//   const Comment: AgColDefsI = {
//     headerName: "Comment", 
//     field: 'comment', 
//     minWidth: 150,
//     headerComponent: CustomHeaderComponent,
//     sortable: true,
//     cellClass:"ps-2",
//     editable:false,
//     cellRenderer:TextRendererComponent
//   };

//   export const TransactionHistoryListColumnDef:AgColDefsI[] = [
//     Type ,
//     TransferFrom ,
//     DepositInto ,
//     Against ,
//     TransactionNo,
//     TransactionDt,
//     AmountColumn,
//     Comment,
//  ]
// export const AgGridDataModelTransactionHistoryList: AgGridI = {
//     colDefs: TransactionHistoryListColumnDef,
//     rowSelection: "multiple",
//     rowHeight:40,
// }

// new transaction history 

const ExpandableColumn: AgColDefsI =
{
  headerName: "",
  field: "isExpandable",
  lockPosition: "left",
  headerComponent: CustomHeaderComponent,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
  lockPinned: true,
  suppressMovable: false,
  wrapText: true,
  sortable: false,
  autoHeight: true,
  resizable: false,
  cellClass: "custom-column-group-cell text-end ",
  minWidth: 0,
  maxWidth: 0,
  flex: 0,
  cellStyle: {
    position: "relative",
    top: "0px",
    minWidth: "100%",
    // innerHeight:"380px",
    // left: "0 !important",
  },
  cellClassRules: { "borders-0": (params) => !params?.data?.isExpandable ?? false, },
  cellRenderer: CustomExpandableComponent,
  cellRendererParams: { context: this },
  width: 0,
}


const LedgerNameColumn: AgColDefsI =
{
  headerName: "Name",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
  field: "accountLedgerName",
  cellClass: "custom-column-group-cell text-primary px-2",
  flex: 1,
   minWidth: 100,
  cellRenderer: TextRendererComponent,
  cellRendererParams: { isCursor: true },
  lockPinned: true,
  lockPosition: 'left',
  suppressMovable: false,
  editable: false
}
const DateColumn: AgColDefsI =
{
  headerName: "Date",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  field: "date",
   minWidth: 100,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  editable: false,
  cellRenderer: TextSvgCellrenderComponent,
   cellRendererParams: { isCenter: true },
  valueFormatter: (params) => {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(params.value, 'MM-dd-yyyy');
  }
}
// const VoucherNoColumn: AgColDefsI = {
//   headerName: "Voucher No.",
//   headerComponent: CustomHeaderComponent,
//   sortable: true,
//   editable: false,
//   headerClass:
//     "px-0  sale-bill-columns custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
//   field: "voucherNo",
//   cellClass: "px-1 custom-column-group-cell text-end",
//   flex: 2,
//   cellRenderer: TextRendererComponent,
//   headerComponentParams: {
//     filterValueColumnName: "invoiceNo",
//     filterIdColumnName: "invoiceNo",
//     isInputFilter: true,
//   },

// }

const VoucherNoColumn: AgColDefsI = {
  headerName: "Voucher No.", 
  field: 'voucherNo', 
  headerComponent: CustomHeaderComponent,
  minWidth: 100,
  sortable: true,
  flex:1,
  editable:false,
  headerClass:'px-2 text-truncate',
  cellClass:'ps-0 pe-2 d-flex align-item-center',
  cellRenderer:TextRendererComponent
};

const ActionColumn: AgColDefsI = {
  headerName: "",
  field: 'action',
  suppressNavigable: true,
  suppressMovable: false,
  editable: false,
  minWidth: 60,
  maxWidth: 60,
  headerClass: " px-0 ag_header_center",
  headerComponentParams: { enablePlusIcon: true },
  sortable: true,
  lockPinned:true, 
  lockPosition:'right',
  cellRendererParams: {
    isDeleteIcon: false,
    editIcon: true,
  },
  cellRenderer: ResetDeleteIconComponent,
  cellClass: "gap-5",
};

const TypeColumn: AgColDefsI =
{
  headerName: "Type",
  headerComponent: CustomHeaderComponent,
  field: "voucherType",
  minWidth: 100,
  sortable: true,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start text-truncate",
  cellClass: "custom-column-group-cell px-2",
  flex: 1,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  suppressMovable: false,
  editable: false
}
const TransferFromColumn: AgColDefsI =
{
  headerName: "Transfer From",
  headerComponent: CustomHeaderComponent,
  field: "transferName",
  sortable: true,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start text-truncate",
  cellClass: "custom-column-group-cell px-2",
  flex: 1,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
   minWidth: 100,
  suppressMovable: false,
  editable: false
}
const AgainstColumn: AgColDefsI =
{
  headerName: "Against",
  headerComponent: CustomHeaderComponent,
  field: "againstName",
  sortable: true,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start text-truncate",
  cellClass: "custom-column-group-cell px-2",
  flex: 1,
   minWidth: 100,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  suppressMovable: false,
  editable: false
}
const TransactionNumberColumn: AgColDefsI =
{
  headerName: "Transaction No.",
  headerComponent: CustomHeaderComponent,
  field: "transactionNo",
  sortable: true,
  minWidth: 120,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start text-truncate",
  cellClass: "custom-column-group-cell px-2",
  flex: 1,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  suppressMovable: false,
  editable: false
}
const TransactionDateColumn: AgColDefsI =
{
  headerName: "Transaction Dt.",
  headerComponent: CustomHeaderComponent,
  field: "transactionDate",
  sortable: true,
  minWidth: 120,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start text-truncate",
  cellClass: "custom-column-group-cell px-2",
  flex: 1,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  suppressMovable: false,
  editable: false
}
const AmountColumn: AgColDefsI =
{
  headerName: "Amount",
  headerComponent: CustomHeaderComponent,
  field: "amount",
  sortable: true,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  cellClass: " ag_cell_end custom-column-group-cell",
  flex: 1,
   minWidth: 100,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  suppressMovable: false,
  editable: false
}
const CommentColumn: AgColDefsI =
{
  headerName: "Comment",
  headerComponent: CustomHeaderComponent,
  field: "comment",
  sortable: true,
  headerClass: "px-2 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start text-truncate",
  cellClass: "custom-column-group-cell px-2",
  flex: 1,
   minWidth: 100,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  suppressMovable: false,
  editable: false
}

export const ColDefsPaymentVoucherList: AgColDefsI[] =
  [
    // ExpandableColumn,
    LedgerNameColumn,
    TypeColumn,
    TransferFromColumn,
    AgainstColumn,
    TransactionNumberColumn,
    TransactionDateColumn,
    AmountColumn,
    CommentColumn,
    DateColumn,
    VoucherNoColumn,
    ActionColumn

  ]

export const AgGridDataModelTransactionHistoryList: AgGridI =
{
  colDefs: ColDefsPaymentVoucherList,
  rowSelection: "multiple",
  rows: [],
  headerHeight: 70,
  isFilter: true,
  isServerSidepagination: true,
  showPagination: true,
};